var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timetable-wrapper timetable-text-wrapper"},[_c('timetable-view-text',{attrs:{"date":_vm.date,"events":_vm.events,"texts":_vm.texts}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }